import { Unit } from "../../entities/unit";
import { AxiosHttpClient } from "../httpClient/axios-http-client.service";

export type Person = {
  id: string;
  unit_id: string;
  name: string;
  email?: string;
  phone?: string;
  date_of_birth?: string;
  date_baptism?: string;
  created_at?: string;
  updated_at?: string;
};

export type CreateUnitInput = {
  church_id: string;
  name: string;
  teacher_ids: string[];
};

export type UpdateUnitInput = {
  name: string;
  teacher_ids: string[];
};

export class UnitService extends AxiosHttpClient {
  public static async get(): Promise<Unit[]> {
    const { data: { data } } = await this.axiosHttpClient.get("/units");
    return data;
  }

  public static async getById(unitId: string): Promise<Unit> {
    const { data: { data } } = await this.axiosHttpClient.get(`/units/${unitId}`);
    return data;
  }

  public static async create(input: CreateUnitInput): Promise<Unit> {
    const { data: { data } } = await this.axiosHttpClient.post("/units", input);
    return data;
  }

  public static async update(unitId: string, input: UpdateUnitInput): Promise<Unit> {
    const { data: { data } } = await this.axiosHttpClient.put(`/units/${unitId}`, input);
    return data;
  }

  public static async remove(unitId: string): Promise<void> {
    await this.axiosHttpClient.delete(`/units/${unitId}`);
  }

  public static async getPeople(unitId: string): Promise<Person[]> {
    const { data: { data } } = await this.axiosHttpClient.get(`/units/${unitId}/people`);
    return data;
  }

  public static async getMissingStudents(): Promise<{ name: string }[]> {
    const { data: { data } } = await this.axiosHttpClient.get("/units/missing-students");
    return data;
  }
}
